<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar title="系统设置">
        <template #left>
          <van-icon name="arrow-left" size="24" @click="goBack"/>
        </template>
      </van-nav-bar>
    </div>

    <div class="apply-body">
      <van-skeleton :loading="loading" :row="3" :style="{ paddingTop: '16px' }">
        <van-empty v-if="dataList.length < 1" description="暂无设置项" />
        <van-cell-group v-if="dataList.length > 0">
          <van-cell v-for="data in dataList" :key="data"
                    :title="data['configName']">
            <template #label>
              <span>{{ data['remark'] }}</span>
            </template>
            <template #right-icon>
              <van-switch v-if="data['configType'] === 'switch'"
                          v-model="switchModel[data['configKey']]"
                          @change="changeSwitch(data['configKey'], switchModel[data['configKey']])" />
              <van-stepper v-if="data['configType'] === 'stepper'" integer
                           v-model="data['configValue']"
                           @change="changeStepper(data['configKey'], data['configValue'])" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-skeleton>
    </div>

  </div>
</template>

<script>
import {editConfig, getConfigList} from "@/api";
import {showNotify} from "vant";

export default {
  name: "SystemConfig",
  data() {
    return {
      loading: true,
      dataList: [],
      switchModel: {},
    }
  },
  mounted() {
    this.loading = true;
    getConfigList().then((res) => {
      if (res.code === 200) {
        this.dataList = res.data;
        for (let i = 0; i < res.data.length; i++) {
          let config = res.data[i];
          let configType = config['configType'];
          if (configType === 'switch') {
            let configValue = config['configValue'];
            if (configValue === 'Y') {
              this.switchModel[config['configKey']] = true;
            } else {
              this.switchModel[config['configKey']] = false;
            }
          }
        }
        this.loading = false;
      } else {
        showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
      }
    });
  },
  methods: {
    goBack() {
      window.history.back();
    },
    changeSwitch(key, value) {
      if (value === true) {
        value = 'Y';
      } else {
        value = 'N';
      }
      editConfig('key=' + key + '&value=' + value).then((res) => {
        if (res.code === 200) {
          showNotify({ type: 'success', message: res.msg, position: 'top' });
        } else {
          showNotify({ type: 'danger', message: res.msg, position: 'top' });
        }
      });
    },
    changeStepper(key, value) {
      editConfig('key=' + key + '&value=' + value).then((res) => {
        if (res.code === 200) {
          showNotify({ type: 'success', message: res.msg, position: 'top' });
        } else {
          showNotify({ type: 'danger', message: res.msg, position: 'top' });
        }
      });
    },
  },
}
</script>

<style scoped>
.apply {
  width:100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
  background-color: rgb(248,248,248);
  padding-bottom: 10px;
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding-bottom: 20px;
}

</style>